import SignOutPage from './SignOutPage';

export default SignOutPage;
